
import { defineComponent, ref } from "vue";
import { ErrorMessage, Field, Form } from "vee-validate";
import { Actions } from "@/store/enums/StoreEnums";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import * as Yup from "yup";
import Cookies from "js-cookie";

export default defineComponent({
  name: "sign-in",
  components: {
    Field,
    Form,
    ErrorMessage,
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    const submitButton = ref<HTMLElement | null>(null);
    let is_error = false;

    //Create form validation object
    const login = Yup.object().shape({
      username: Yup.string()
        .min(4, "Username minimal 4 karakter")
        .required("Username wajib diisi")
        .label("Username"),
      password: Yup.string()
        .min(4, "Password minimal 4 karakter")
        .required("Password wajib diisi")
        .label("Password"),
      rememberMe: Yup.number()
        .nullable()
        .default(0)
    });

    const initialValues = {
      username: "",
      password: "",
      rememberMe: 0
    };

    const onSubmitLogin = (values: any) => {
      let formData = new FormData();
      formData.append("username", values.username);
      formData.append("password", values.password);
      formData.append("rememberMe", values.rememberMe?.toString() || "0");

      // Clear existing errors
      store.dispatch(Actions.LOGOUT);

      if (submitButton.value) {
        // Activate indicator
        submitButton.value.setAttribute("data-kt-indicator", "on");
      }

      // Send login request
      store
        .dispatch(Actions.LOGIN, formData)
        .then(() => {
          let last_page = Cookies.get("last_page");
          if (last_page) {
            router.push(last_page);
          } else {
            // Go to page after successfully login
            router.push({ name: "dashboard" });
          }
        })
        .catch((error) => {
          submitButton.value?.removeAttribute("data-kt-indicator");
          is_error = true;
          Swal.fire({
            text: store.getters.getErrors,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Try again!",
            customClass: {
              confirmButton: "btn fw-bold btn-light-danger",
            },
          });
        })
        .finally(() => {
          submitButton.value?.removeAttribute("data-kt-indicator");
        });
    };

    return {
      onSubmitLogin,
      login,
      submitButton,
      is_error,
      initialValues
    };
  },
});
